import { signIn, type SignInInput } from "aws-amplify/auth";

/**
 * Shared Amplify UI `<Authenticator>` services override.
 *
 * WHY: The lazy Cognito UserMigration Lambda trigger on the new Gen2 pool only
 * fires when Cognito receives the user's plaintext password so it can
 * re-authenticate them against the OLD pool. Amplify's default sign-in flow is
 * USER_SRP_AUTH, which (by design) never sends the password — so the trigger
 * never runs and un-migrated legacy users cannot sign in. This was the root
 * cause of the Aug 2026 prod cutover revert (commit fb6cf34).
 *
 * FIX: Force the Authenticator's sign-in call to use USER_PASSWORD_AUTH, which
 * sends the password to Cognito over TLS. The new pool's app client must also
 * allow this flow (ALLOW_USER_PASSWORD_AUTH — enabled in amplify/backend.ts).
 *
 * This is the migration-window steady state. Revisit SRP-only after the old
 * pool is decommissioned.
 *
 * Apply to every `<Authenticator>` instance via the `services` prop.
 */
export const authenticatorServices = {
  async handleSignIn(input: SignInInput) {
    const { username, password, options } = input;
    return signIn({
      username,
      password,
      options: {
        ...options,
        authFlowType: "USER_PASSWORD_AUTH",
      },
    });
  },
};
